import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { Tabs } from "antd";
import {
  BarChartOutlined,
  GroupOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import GanttChart from "./GanttChart";
import BatchManager from "./BatchManager";
import CapacityDashboard from "./CapacityDashboard";
import PageTitle from "../page-header/PageHeader";
import checkTokenExp from "../../utils/checkTokenExp";

/**
 * SchedulingLayout — top-level container with tabs for
 * Gantt, Batches and Capacity views.
 */
const SchedulingLayout = () => {
  const isLogged = Boolean(localStorage.getItem("isLogged"));
  const accessToken = localStorage.getItem("access-token");

  const [activeTab, setActiveTab] = useState("gantt");

  // ── Auth guard (after hooks) ───────────────────────────────
  if (!isLogged) {
    return <Navigate to="/auth/login" replace />;
  }
  checkTokenExp(accessToken);

  const items = [
    {
      key: "gantt",
      label: (
        <span>
          <BarChartOutlined /> Gantt Chart
        </span>
      ),
      children: <GanttChart />,
    },
    {
      key: "batches",
      label: (
        <span>
          <GroupOutlined /> Batches
        </span>
      ),
      children: <BatchManager />,
    },
    {
      key: "capacity",
      label: (
        <span>
          <DashboardOutlined /> Capacity
        </span>
      ),
      children: <CapacityDashboard />,
    },
  ];

  return (
    <div>
      <PageTitle title="Back" subtitle="Production Scheduling" />
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        size="large"
        style={{ marginTop: -8 }}
      />
    </div>
  );
};

export default SchedulingLayout;
